import { toHex } from '../core/bytes/encoding';

export const fmtInt = (n: number): string => n.toLocaleString('en-US');

export function fmtTime(ms: number | Date | undefined): string {
  if (ms === undefined) return '—';
  const d = ms instanceof Date ? ms : new Date(ms);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, ' UTC');
}

export function fmtRelative(ms: number | Date | undefined, now = Date.now()): string {
  if (ms === undefined) return '';
  const t = ms instanceof Date ? ms.getTime() : ms;
  const diff = now - t;
  const abs = Math.abs(diff);
  const units: Array<[number, string]> = [
    [1000, 's'],
    [60_000, 'min'],
    [3_600_000, 'h'],
    [86_400_000, 'd'],
  ];
  let value = abs / 1000;
  let unit = 's';
  for (const [size, name] of units) {
    if (abs >= size) {
      value = abs / size;
      unit = name;
    }
  }
  const v = value < 10 ? value.toFixed(1).replace(/\.0$/, '') : Math.round(value).toString();
  return diff >= 0 ? `${v}${unit} ago` : `in ${v}${unit}`;
}

export const hex = (b: Uint8Array | undefined): string => (b ? toHex(b) : '');

export function shortHex(b: Uint8Array | string | undefined, keep = 8): string {
  const h = typeof b === 'string' ? b : hex(b);
  if (h.length <= keep * 2 + 1) return h;
  return `${h.slice(0, keep)}…${h.slice(-keep)}`;
}

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} kB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** Parses a user-typed integer (allowing separators) or returns undefined. */
export function parseIndex(s: string): number | undefined {
  const t = s.replace(/[\s,_]/g, '');
  if (!/^\d+$/.test(t)) return undefined;
  const n = Number(t);
  return Number.isSafeInteger(n) ? n : undefined;
}
